/* eslint-disable arrow-body-style */
import React, { useState } from 'react';
import HaesCard from '../HaesCard/HaesCard';
import './Tabs.css';

const Tabs = () => {
  const [toogleTab, setToogleTab] = useState(1);

  const handleToogle = (index) => {
    setToogleTab(index);
  };

  return (
    <div className="tabs">
      <div className="tabs__header">
        <button
          className={toogleTab === 1 ? 'tabs__heading active' : 'tabs__heading'}
          onClick={() => handleToogle(1)}
          type="button"
        >
          Haes
        </button>
        <button
          className={toogleTab === 2 ? 'tabs__heading active' : 'tabs__heading'}
          onClick={() => handleToogle(2)}
          type="button"
        >
          Media
        </button>
        <button
          className={toogleTab === 3 ? 'tabs__heading active' : 'tabs__heading'}
          onClick={() => handleToogle(3)}
          type="button"
        >
          Likes
        </button>
      </div>
      <div className="tabs__content">
        <div className={toogleTab === 1 ? 'active-content content' : 'content'}>
          <HaesCard />
        </div>
        <div className={toogleTab === 2 ? 'active-content content' : 'content'}>
          <HaesCard />
        </div>
        <div className={toogleTab === 3 ? 'active-content content' : 'content'}>
          <HaesCard />
        </div>
      </div>
    </div>
  );
};

export default Tabs;
